/**
 * Per-match prediction status badge.
 * pt-BR copy.
 */

import { CheckCircle2, AlertCircle, Loader2, Clock, AlertTriangle } from 'lucide-react';
import Badge from '../ui/badge';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export type PredictionStatus =
  | { kind: 'locked' }
  | { kind: 'pending' }
  | { kind: 'saving' }
  | { kind: 'saved'; at: number }
  | { kind: 'error' };

export interface PredictionStatusBadgeProps {
  status: PredictionStatus;
}

export default function PredictionStatusBadge({ status }: PredictionStatusBadgeProps) {
  switch (status.kind) {
    case 'locked':
      return (
        <Badge variant="secondary" aria-label="Aposta encerrada">
          <Clock className="w-3 h-3" aria-hidden="true" />
          Encerrado
        </Badge>
      );
    case 'pending':
      return (
        <Badge variant="warning">
          <AlertCircle className="w-3 h-3" aria-hidden="true" />
          Pendente
        </Badge>
      );
    case 'saving':
      return (
        <Badge variant="info">
          <Loader2 className="w-3 h-3 animate-spin" aria-hidden="true" />
          Salvando…
        </Badge>
      );
    case 'saved':
      return (
        <Badge variant="success" aria-live="polite">
          <CheckCircle2 className="w-3 h-3" aria-hidden="true" />
          Salvo às {format(new Date(status.at), 'HH:mm', { locale: ptBR })}
        </Badge>
      );
    case 'error':
      return (
        <Badge variant="destructive" aria-live="polite">
          <AlertTriangle className="w-3 h-3" aria-hidden="true" />
          Falha — tentar novamente
        </Badge>
      );
  }
}
